import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { messages } from './messages'

type MultiInputValidator = (input: string) => {
  valid: boolean
  message?: string
}

export type MultiInputClientValidator = (
  input: string
) => { valid: true } | { valid: false; message: string }

export function validationSuite(
  name: string,
  intl: IntlShape,
  maxEntries?: number,
  inputValidation?: MultiInputValidator
) {
  return create((value: string, selectedValues: string[]) => {
    const { formatMessage: i18n } = intl
    const { validation } = messages

    test(name, '', () => {
      enforce(value).isNotEmpty()
    })

    omitWhen(!maxEntries, () => {
      test(name, i18n(validation.maxEntries, { limit: maxEntries }), () => {
        enforce(selectedValues.length).lessThan(maxEntries)
      })
    })

    test(name, i18n(validation.duplicated, { item: value }), () => {
      enforce(value).notInside(selectedValues)
    })

    omitWhen(!inputValidation, () => {
      const clientValidation = inputValidation?.(value)

      test(name, clientValidation?.message ?? '', () => {
        enforce(clientValidation?.valid).isTruthy()
      })
    })
  })
}
